import { watch } from 'vue'

import { getDocument } from '@/helpers/globals'
import { useGtmVar } from './useGtmVar'
import { useUtmParams } from './useUtmParams'
import { useAuth } from '@/plugins/auth.ts'
import { useMarketingDataMutation } from '@/composables/app/gtm/useAnalytics.generated.ts'
import { useMsClarity } from '@/composables/third-party/clarity.ts'

export function useAnalytics(): void {
    const document = getDocument()

    if (import.meta.env.SSR || import.meta.env.DEV || !document) {
        return
    }

    const {
        ft_utm_source,
        ft_utm_medium,
        ft_utm_campaign,
        lt_utm_source,
        lt_utm_medium,
        lt_utm_campaign,
        client_id,
        session_id,
        gclid,
        fbp,
        fbclid,
    } = useUtmParams()

    useGtmVar('customer-id', client_id)
    useGtmVar('session-id', session_id)

    const { executeMutation } = useMarketingDataMutation()

    const { user } = useAuth()
    const userID = useGtmVar('userID', user.value?.id || '')

    watch(
        user,
        (newUser) => {
            if (newUser) {
                userID.value = newUser.id

                executeMutation({
                    input: {
                        ftUtm: {
                            source: ft_utm_source.value,
                            medium: ft_utm_medium.value,
                            campaign: ft_utm_campaign.value,
                        },
                        ltUtm: {
                            source: lt_utm_source.value,
                            medium: lt_utm_medium.value,
                            campaign: lt_utm_campaign.value,
                        },
                        clientId: client_id.value,
                        sessionId: session_id.value,
                        gclid: gclid.value,
                        fbp: fbp.value,
                        fbclid: fbclid.value,
                    },
                })
            } else {
                userID.value = ''
            }
        },
        { immediate: true }
    )

    useMsClarity()
}
